import React, { Component } from "react"
import PropTypes from "prop-types"
import { translate } from "react-i18next"
import ItemNameCountShape from "../../state/shapes/ItemNameCountShape"
import Widget from "../layout/widget/Widget"
import { getBarChartSeriesFromItemNameCountShape } from "../../utils/widget-utils"
import BarChart from "../charts/generic/BarChart"
import ShowAllButton from "./ShowAllButton"

class TopUsedFeatures extends Component {
  state = {
    chartIsScrollable: false
  }

  seeAllData = () => {
    this.setState({
      chartIsScrollable: !this.state.chartIsScrollable
    })
  }

  translateChartData = chartData => {
    const output = []
    if (chartData && chartData.length > 0) {
      chartData.forEach(x => output.push([this.props.t(x[0]), x[1]]))
    }
    return output
  }

  render() {
    let chartData = getBarChartSeriesFromItemNameCountShape(this.props.data)
    chartData = this.translateChartData(chartData)

    const { exportEndpoint, appliedFilters, subtitleKey } = this.props
    const titleKey="Widgets.TopUsedFeatures.Title"
    return (
      <Widget
        columns={1}
        titleKey={titleKey}
        helpKey="Widgets.TopUsedFeatures.Help"
        exportEndpoint={exportEndpoint}
        appliedFilters={appliedFilters}
        subtitleKey={subtitleKey}
      >
        <BarChart
          data={chartData}
          yAxisTitle="Widgets.TopUsedFeatures.Responses"
          xAxisTitle="Common.Percentage"
          scrollbarEnabled={this.state.chartIsScrollable}
          titleKey={titleKey}
          subtitleKey={subtitleKey}
        />

        <ShowAllButton onClick={this.seeAllData} isActive={this.state.chartIsScrollable} />
      </Widget>
    )
  }
}

TopUsedFeatures.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape(ItemNameCountShape)).isRequired,
  exportEndpoint: PropTypes.string.isRequired,
  subtitleKey: PropTypes.string
}

export default translate()(TopUsedFeatures)



// WEBPACK FOOTER //
// ./src/components/widgets/TopUsedFeatures.jsx